import { snakeCaseToWords, capitalizeFirst, capitalizeWords, capSnake } from "../utility";
import * as D from 'date-fns';

export class DevUtil {
  constructor() {
    this.setup();
  }
  setup() {
    this.logObj = (obj) => {
      console.log(JSON.stringify(obj, null, 2));
      navigator.clipboard.writeText(JSON.stringify(obj, null, 2));
    }
  }
}
export const devUtil = new DevUtil();

export const DevUtilPlugin = (Vue) => ({
  install() {
    Vue.ut = devUtil;
    Vue.prototype.$ut = devUtil;
  }
})